import { useCallback, useEffect } from 'react';
import {
  createBrowserRouter,
  Link,
  Outlet,
  RouterProvider,
  ScrollRestoration,
  useLoaderData,
  useLocation,
  useNavigation,
} from "react-router-dom";
import { ToastContainer } from 'react-toastify';
// routes
import Router from './router/routes';
// theme
import ThemeProvider from './theme';
// components
import { ScrollToTop } from './components/scroll-to-top';
// hooks
import { AuthProvider } from './contexts/AuthContext';
import { MessageOverlay } from './components/toastify';
import { resetStore } from './store';


// toast options
const options = {
    position: 'top-center',
    autoClose: 2000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'colored',
    closeButton: false
};


const useBrowserClose = () => {
  useEffect(() => {
      const handleBeforeUnload = (event) => {
          // 標準做法：設置 returnValue 觸發瀏覽器默認提示
          event.preventDefault();
          resetStore();
      };

      const handleVisibilityChange = () => {
          if (document.visibilityState === 'hidden') {
              // console.log('標籤頁已被隱藏');
          }
      };

      const handleUnload = () => {
          // Example: Send a logout request or perform cleanup
          // navigator.sendBeacon('/api/logout', JSON.stringify({ userId: 123 }));
      };

      window.addEventListener('beforeunload', handleBeforeUnload, true);
      window.addEventListener('unload', handleUnload);
      document.addEventListener('visibilitychange', handleVisibilityChange);

      return () => {
          window.removeEventListener('beforeunload', handleBeforeUnload, true);
          window.removeEventListener('unload', handleUnload);
          document.removeEventListener('visibilitychange', handleVisibilityChange);
      };
  }, []);
};

// ================================|| App ||================================ /
export default function App() {
  // useBrowserClose();
  return (
    <ThemeProvider>
      <MessageOverlay />
      <ToastContainer {...options} />
      <Router />
    </ThemeProvider>
  );
}


/* export default function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <ToastContainer {...options} />
        <ScrollToTop />
        <Router />
      </ThemeProvider>
    </AuthProvider>
  );
} */
